import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  Output
} from "@angular/core";
import {
  genderLabelMap,
  roles,
  rolesLabelMap,
  userStatusMap
} from "../../../../../constants/common.constants";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {CommonService} from "../../../../../services/common.service";
import * as Validation from "../../../../../constants/validation.constants";
import {
  PhoneNumberFormatPipe
} from "../../../../../pipes/phone-number-format.pipe";
import * as moment from "moment";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../../state/app.state";
import {
  EditPhoneNumberComponent
} from "../../edit-phone-number/edit-phone-number.component";
import {
  DeleteUserRequest,
  EditProfileByUserIdRequest,
  EditProfileRequest,
  FetchGenderFilterRequest,
  FetchProfileRequest,
  FetchUserStatusFilterRequest,
  OtpSentStatus,
  TriggerNotificationRequest
} from "../../../../../core/shared.actions";
import {Subject, takeUntil} from "rxjs";
import {
  DropdownOption
} from "../../../../../../../models/dropdown-option.model";
import {
  genderInfo,
  profile,
  selectedUserProfile,
  userStatusInfo
} from "../../../../../core/shared.selectors";
import * as $ from "jquery";
import {
  NotificationTypeKeyMap
} from "../../../../../constants/notification.config";
import {environment} from "../../../../../../../../environments/environment";
import {ActivatedRoute} from "@angular/router";

@Component({
  selector: "app-editable-user-details",
  templateUrl: "./editable-user-details.component.html",
  styleUrls: ["./editable-user-details.component.css"]
})
export class EditableUserDetailsComponent implements OnChanges,
                                                     OnDestroy {
  @Input() userDetails;
  @Input() loading;
  @Output() handleClick = new EventEmitter();
  @Input() hasUserId: boolean;
  @Input() loggedInUserRole: number;


  minDobDate: any;
  maxDobDate: any;
  errorMessages: any = {};
  errorMessageMap = {
    firstName: {
      required: "This field is required.",
      pattern: "Only alphabets allowed",
      minlength: "Minimum 1 characters required",
      maxlength: "Maximum 50 characters accepted",
    },
    lastName: {
      required: "This field is required.",
      pattern: "Only alphabets allowed",
      minlength: "Minimum 1 characters required",
      maxlength: "Maximum 50 characters accepted"
    },
    email: {
      required: "This field is required.",
      pattern: "Invalid Email Id"
    },
    username: {
      required: "This field is required.",
      pattern: "Pattern Error"
    },
    dob: {
      required: "This field is required."
    },
    gender: {
      required: "This field is required."
    },
    role: {
      required: "This field is required."
    },
    phoneNumber: {
      required: "This field is required."
    },
    userStatus: {
      required: "This field is required."
    },
  };
  validation = Validation;
  avatarId: any;
  genderDropdownOptions: DropdownOption[] = [];
  userStatusDropdownOptions: DropdownOption[] = [];
  form = new FormGroup({
    firstName: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required,
        Validators.pattern(this.validation.user.firstName.regex),
        Validators.minLength(this.validation.user.firstName.length.min),
        Validators.maxLength(this.validation.user.firstName.length.max),
      ]
    }),
    lastName: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required,
        Validators.pattern(this.validation.user.lastName.regex),
        Validators.minLength(this.validation.user.lastName.length.min),
        Validators.maxLength(this.validation.user.lastName.length.max),
      ]
    }),
    email: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required,
        Validators.pattern(this.validation.email.regex)
      ]
    }),
    username: new FormControl({value: "", disabled: true}, {
      validators: [
        Validators.required,
        Validators.pattern(this.validation.user.username.regex),
        Validators.minLength(this.validation.user.username.length.min),
        Validators.maxLength(this.validation.user.username.length.max),
      ]
    }),
    dob: new FormControl({value: "", disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    gender: new FormControl({value: -1, disabled: false}, {
      validators: [
        Validators.required
      ]
    }),
    userStatus: new FormControl({value: null, disabled: true}, {
      validators: [
        Validators.required
      ]
    }),
    role: new FormControl({value: "", disabled: true}, {
      validators: [
        Validators.required
      ]
    }),
    phoneNumber: new FormControl({value: "", disabled: true}, {
      validators: [
        Validators.required,
        Validators.minLength(this.validation["phoneNumber"].length.min)
      ]
    }),
  });
  genderInfoLoading: boolean = false;
  userStatusLoading: boolean = false;
  selectedUserRole: number;
  userRole: number;
  userId: any;
  protected readonly genderLabelMap = genderLabelMap;
  protected readonly rolesLabelMap = rolesLabelMap;
  protected readonly roles = roles;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private commonService: CommonService,
    private route: ActivatedRoute,
    private phoneNumberFormatPipe: PhoneNumberFormatPipe,
    private store: Store<fromRoot.State>,
  ) {
    const params: any = this.route.snapshot.params;

    if (params.clientAdminId || params.coachId || params.memberId) {
      this.userId = params.clientAdminId || params.coachId || params.memberId;
    }

    this.store.dispatch(FetchGenderFilterRequest());
    this.store.dispatch(FetchUserStatusFilterRequest());
  }

  ngOnInit() {

  }

  ngOnChanges() {

    if (this.hasUserId) {

      this.store.select(profile)
        .pipe(takeUntil(this.onDestroy))
        .subscribe(data => {
          this.userRole = data?.role;
        });

      this.store.select(selectedUserProfile)
        .pipe(takeUntil(this.onDestroy))
        .subscribe(data => {
          this.selectedUserRole = data?.profile?.role;
        });

      if (
        this.userRole <= roles['coach'] &&
        this.selectedUserRole > this.userRole &&
        this.userDetails?.status?.key > userStatusMap["inProcess"]
      ) {
        this.form.controls['userStatus'].enable({emitEvent: false});
      }

    }

    if (this.userDetails?.role === roles['participant']) {
      this.maxDobDate = moment().subtract(1, 'days');
      this.minDobDate = moment().subtract(18, 'year');
    } else {
      this.maxDobDate = moment().subtract(18, 'year');
    }

    this.store.select(genderInfo).pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.genderInfoLoading = data.loading;
        this.genderDropdownOptions = data?.list;
      });

    this.store.select(userStatusInfo).pipe(takeUntil(this.onDestroy))
      .subscribe((data: any) => {
        this.userStatusLoading = data.loading;
        this.userStatusDropdownOptions = data?.list.filter(eachStatus => {
          return eachStatus.key > 1
        });
      });

    this.form.patchValue({
      firstName: this.userDetails?.firstName,
      lastName: this.userDetails?.lastName,
      email: this.userDetails?.emailId,
      username: this.userDetails?.username,
      dob: this.userDetails?.dob,
      gender: this.userDetails?.gender?.key,
      role: rolesLabelMap[this.userDetails?.role],
      phoneNumber: this.userDetails?.phoneNumber,
      userStatus: this.userDetails?.status?.key,
    });
  }

  checkForErrors(currentField?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  save() {
    if (this.form.invalid) {
      this.checkForErrors();
      setTimeout(() => {
        $(".form-field.ng-invalid")[0].parentElement.scrollIntoView();
      }, 0);
      return;
    }

    this.form.markAsPristine();

    const {
      firstName,
      lastName,
      dob,
      gender,
      email,
      userStatus,
    } = this.form.getRawValue();

    const payload = {
      firstName,
      lastName,
      dob: moment(dob).toISOString(),
      gender,
      emailId: email,
      ...(this.userRole <= roles['coach'] &&
          this.selectedUserRole > this.userRole &&
          this.userDetails?.status?.key > userStatusMap["inProcess"] ? {status: userStatus} : {}),
      avatarId: this.avatarId,
    };

    if (this.hasUserId) {
      payload['forUserId'] = this.userDetails?.id;
      this.store.dispatch(EditProfileByUserIdRequest({payload}));
    } else {
      this.store.dispatch(EditProfileRequest({payload}));
    }
  }

  close() {
    this.handleClick.emit(false);
  }

  selectAvatar(avatar) {
    this.avatarId = avatar.id;
    this.form.markAsDirty();
  }

  hippaConsentClicked() {
    const url = `${environment.cdnBaseUrl}${this.userDetails.consentLink}`;
    window.open(url);
  }

  hippaAssentClicked() {
    const url = `${environment.cdnBaseUrl}${this.userDetails.assentLink}`;
    window.open(url);
  }

  editPhoneNumber() {
    this.commonService.openDialog({
      data: {
        component: EditPhoneNumberComponent,
        phoneNumber: this.userDetails?.phoneNumber
      }
    }).afterClosed().subscribe(() => {
      this.store.dispatch(FetchProfileRequest());
      this.store.dispatch(OtpSentStatus({otpSent: false}));
    });
  }

  triggerNotification(type: string) {
    this.store.dispatch(TriggerNotificationRequest({
      payload: {
        userId: this.userDetails.id,
        type: NotificationTypeKeyMap[type]
      }
    }))
  }

  deleteUser() {
    this.commonService.openConfirmationDialog({
        data: {
          message: 'Are you sure you want to continue with delete?',
          submitText: 'Yes',
          classList: 'w-[40vw]',
          handleSubmit: () => {
            let payload = {
              userId: this.userId
            }
            this.store.dispatch(DeleteUserRequest({payload}));
          },
          cancelText: 'No',
          handleCancel: () => {
            this.commonService.closeDialog();
          }
        }
      }
    )
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }

}
